<div class="receipt-wrap container py-4">
    <div class="receipt card p-4 shadow-sm mx-auto" style="max-width:720px;">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center gap-3">
                <img src="/assets/images/kinvyt-gold.png" alt="Kinvyt" class="receipt-logo" />
                <div>
                    <!-- <h5 class="m-0">Kinvyt</h5> -->
                    <small class="text-muted">Payment Acknowledgement</small>
                </div>
            </div>
            <div class="text-end">
                <div class="text-muted small">{{ date | date:'medium' }}</div>
                <div class="text-muted small">Ack. Key: {{ tenantKey || '—' }}</div>
            </div>
        </div>

        <hr />

        <div class="row mb-3">
            <div class="col-md-6 mb-2">
                <div class="label">Order ID</div>
                <div class="value"><code>{{ orderId || '—' }}</code></div>
            </div>
            <div class="col-md-6 mb-2">
                <div class="label">Transaction ID</div>
                <div class="value d-flex align-items-center gap-2"><code>{{ txId || '—' }}</code>
                    <button class="btn btn-sm btn-outline-secondary  no-print" (click)="copyTxId()">Copy</button>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-6">
                <div class="label">Amount</div>
                <div class="value"><strong>₹ {{ amount ?? '—' }}</strong></div>
            </div>
            <div class="col-md-6">
                <div class="label">Event ID</div>
                <div class="value"><small class="text-muted">{{ tenantId || '—' }}</small></div>
            </div>
        </div>

        <hr />

        <div class="d-flex justify-content-between align-items-center">
            <div>
                <small class="text-muted">This is a gift acknowledgement. No invoice will be issued.</small>
            </div>
            <div class="d-flex gap-2 no-print">
                <button class="btn btn-outline-secondary" (click)="print()">Print</button>
                <a [routerLink]="['/', tenantKey]" class="btn btn-theme">Close</a>
            </div>
        </div>
    </div>
</div>